import { Component, OnInit, Input, ViewChild, EventEmitter, Output, Inject, ElementRef, HostListener } from '@angular/core';
import { PatientSearchService } from 'src/app/patient-search/patient-search.service';
import { Subject } from 'rxjs/Subject';
import { ContactInfo, IPersonalInfo, SearchInfo } from 'src/app/models/IPersonalInfo';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { element } from 'protractor';
import { IPatientSearch } from 'src/app/models/IPatientSearch.model';
import { IOrderNote } from 'src/app/models/IOrderNote';
import { DatePipe } from '@angular/common';
import { MatSidenav, MatDialog, MatTableDataSource, MatPaginator, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonComponents } from '../Sharedservice/CommonComponents';
import { IAppointmentData } from '../models/IAppointmentDetails';
import { Router } from '@angular/router';
import { OrderNoteDialogComponent } from './order-note-dialog/order-note-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { PatientBannerService } from '../patient-banner/patient-banner.service';
import { NgxMaskModule } from 'ngx-mask';
import { Location } from '@angular/common';
import { SharedService } from '../Sharedservice/SharedService';
import { IAlerts } from '../models/IAlerts';
import { PopupAlertsComponent } from '../ChildControls/popup-alerts/popup-alerts.component';
import { LockService } from '../Services/LockService/lock-service.service';
import { IPatientDetails } from '../models/IEPrescriptionXMLDTO';
import { AESAlgorithm } from '../Utilities/Crypto/AESAlgorithm';
import { ILocationDetails } from '../models/ILocationDetails';
import { SchedularServiceService } from '../Services/Schedular/schedular-service.service';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { T } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-patient-search',
  templateUrl: './patient-search.component.html',
  styleUrls: ['./patient-search.component.css']
})
export class PatientSearchComponent implements OnInit {
  @Output() slideclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() patientBanner: EventEmitter<any> = new EventEmitter<any>();
  @Input() screenName: string;
  PersonalSearchForm: FormGroup;
  personalInfos: IPersonalInfo[];
  dataSource = new MatTableDataSource();
  // displayedColumns: string[] = ['Photo', 'PatientId', 'Name', 'DOB', 'SSN', 'phone', 'zip', 'Action','dPatId'];
  displayedColumns: string[] = ['Photo', 'dPatId','accountNo', 'Name', 'DOB', 'SSN', 'phone', 'zip', 'location','status', 'notes', 'InsuranceName', 'PlanName', 'memberId', 'Action'];
  results: any;
  searchTerm$ = new Subject<string>();
  orderNote: IOrderNote;
  selectedRowIndex: number = -1;
  searchResultStatus: boolean;
  public lstalerts: IAlerts[];
  public PopUpAlerts: IAlerts[] = [];
  public birthdate: Date;
  disableAction: false;
  isdisablebtns: boolean = false;
  selectAllLocations: boolean = true;
  rolealert: string = "";
  role: string = "";
  patIdFilter = new FormControl('');
  patNameFilter = new FormControl('');
  patDOBFilter = new FormControl('');
  patSSNFilter = new FormControl('');
  patphoneFilter = new FormControl('');
  patZipFilter = new FormControl('');
  dpatIdFilter = new FormControl('');
  locationFilter = new FormControl('');
  PatientStatusFilter = new FormControl('');
  notesFilter = new FormControl('');
  InsuranceNameFilter = new FormControl('');
  PlanNameFilter = new FormControl('');
  memberIdFilter = new FormControl('');
  accountNoFilter = new FormControl('');
  filterValues = { patientId: '',AccountNo:'', name: '', patDOB: '', ssn: '', phone: '', postalCode: '', dpatId: '', locationName: '',PatientStatusName: '',PatientNotes:'',insurenceName: '',PlanName:'',MemberId:'' };
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('saveUserId', { static: false }) saveUserId: ElementRef;

  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (event.target.id == "locationsfocus" || event.currentTarget.activeElement.parentElement.id == "userselectLoc") {
      this.SelectedDropDownListId = true
    }
    else {
      event.stopPropagation();
      this.SelectedDropDownListId = false
    }
  }
  
  constructor(public dialogRef: MatDialogRef<PatientSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder
    , private router: Router
    , private patservice: PatientSearchService
    , private sharedService: SharedService
    , public datepipe: DatePipe
    , public dialog: MatDialog
    , private toastr: ToastrService
    , private bannerService: PatientBannerService
    , private location: Location
    , private spinner: NgxSpinnerService
    , private lockService: LockService,
    private crypto: AESAlgorithm,
    private datePipe: DatePipe
    , private schedulerservice: SchedularServiceService
  ) {
    this.spinner.hide();
    this.personalInfos = null;
    this.dataSource.data = [];
    this.getSystem();
    if (this.data != null) {
      this.disableAction = this.data.action;
    }
  }

  formErrors = {
    'locations': '',
  };
  validationMessages = {
    'locations': {
      'required': 'Location is required.',
    },
  };
  getSystem() {

    if (sessionStorage.getItem("patientName") != null || sessionStorage.getItem("patientName") != undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }

  }
  public onload() {
    ;
    this.clearSearch();
  }

  fnSetLocationFromParent() {
    ;
    this.clearSearch();
    this.dataSource.data = [];
    this.getLocations()
    // this.getLocationId = sessionStorage.getItem("LocationId");
    //     if (this.getLocationId == "0") {
    //       this.locationID = this.lstLocations[0].locationName.toString();
    //     } else {
    //       this.locationID = this.lstLocations.filter(x => x.locationId === Number(this.getLocationId))
    //     }

    //     this.lstLocations.filter(x => x.selected = false) // default set false
    //     this.lstLocations.filter(x => x.locationId == this.locationID[0].locationId).map(y => y.selected = true);

    //     this.PersonalSearchForm.patchValue({
    //       locations: this.locationID[0].locationName,
    //     });

  }
  ngOnInit() {
    ;
    this.PersonalSearchForm = this.fb.group({
      patientId: [''],
      lastName: [''],
      firstName: [''],
      DOB: [''],
      SSN: [''],
      postalCode: [''],
      phone: [''],
      isActive: [''],
      dPatId: [''],
      locations: ['', Validators.required],
      IsLocationCheck: [''],
    });
    this.getLocations();
    this.role = sessionStorage.getItem("role");

    this.patIdFilter.valueChanges
      .subscribe(
        patientId => {
          this.filterValues.patientId = patientId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patNameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patDOBFilter.valueChanges
      .subscribe(
        patDOB => {
          this.filterValues.patDOB = patDOB;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patSSNFilter.valueChanges
      .subscribe(
        ssn => {
          this.filterValues.ssn = ssn;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patphoneFilter.valueChanges
      .subscribe(
        phone => {
          this.filterValues.phone = phone;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patZipFilter.valueChanges
      .subscribe(
        postalCode => {
          this.filterValues.postalCode = postalCode;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.locationFilter.valueChanges
      .subscribe(
        locationName => {
          this.filterValues.locationName = locationName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.dpatIdFilter.valueChanges
      .subscribe(
        dPatId => {
          this.filterValues.patientId = dPatId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.notesFilter.valueChanges
      .subscribe(
        PatientNotes => {
          this.filterValues.PatientNotes = PatientNotes;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.PatientStatusFilter.valueChanges
      .subscribe(
        PatientStatusName => {
          this.filterValues.PatientStatusName = PatientStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.InsuranceNameFilter.valueChanges
      .subscribe(
        insurenceName => {
          this.filterValues.insurenceName = insurenceName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.PlanNameFilter.valueChanges
      .subscribe(
        PlanName => {
          this.filterValues.PlanName = PlanName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.memberIdFilter.valueChanges
      .subscribe(
        MemberId => {
          this.filterValues.MemberId = MemberId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      
      this.accountNoFilter.valueChanges
      .subscribe(
        AccountNo => {
          this.filterValues.AccountNo = AccountNo;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  searchquery: SearchInfo;
  contactInformation: ContactInfo[];
  ssNumber: string = ''
  phone: string = '';
  postalcodeFormat: string = '';
  onSubmit() {
    // this.searchquery = new SearchInfo;
    //this.spinner.show();
    sessionStorage.removeItem("IsClosed");
    var checkInputControlInfo = this.checkInputControldata();
    if (checkInputControlInfo == false) {
      return false
    } else {
    }
    this.clearfiltervalues();
    this.createsearchquery();

    // this.searchquery.location
    setTimeout(() => {
      this.searchEntryData();
    }, 100);
  }
  public searchloading: boolean = false;
  searchEntryData() {
    this.searchloading = true;
    this.searchResultStatus = false;

    this.personalInfos = [];
    if (this.searchquery && this.searchquery != undefined) {
      if(this.selectAllLocations){
        this.searchquery.locationId = '';
      }
      this.patservice.searchEntries(this.searchquery)
        .subscribe((results: IPersonalInfo[]) => {
          this.personalInfos = results;
          if (this.personalInfos.length > 0)
            sessionStorage.setItem("searchPatId", this.personalInfos[0].patientId.toString());
          if (sessionStorage.getItem("IsClosed") != "yes") {
            //this.spinner.show();
            if (this.personalInfos.length != 0) {
              this.personalInfos.forEach(i => {
                var element = i;

                //******* SSN Number */

                if (i.ssn == undefined || i.ssn == null || i.ssn == '') {
                  this.ssNumber = '';
                } else {
                  this.ssNumber = i.ssn;
                  var ssn = this.ssNumber.substring(0, 3);
                  var ssn1 = this.ssNumber.substring(3, 5)
                  this.ssNumber = ssn + '-' + ssn1 + '-' + this.ssNumber.substring(5, 9)
                }


                //******* Home Phone / Cell Phone */
                if (i.phone == undefined || i.phone == null || i.phone == '') {
                  this.phone = '';
                } else {
                  var phoneNumbers = i.phone;
                  var numberSplit = phoneNumbers.split(',');
                  var cellPhone = numberSplit[0];
                  var homePhone = numberSplit[1];


                  if (homePhone == undefined || homePhone == null || homePhone == '') {

                    var cellPhoneFormat = cellPhone.substring(0, 3) + '-' + cellPhone.substring(3, 6) + '-' + cellPhone.substring(6, 10);
                    if (cellPhoneFormat == '--') {
                      this.phone = '';
                    } else {
                      this.phone = cellPhoneFormat;
                    }

                  } else {

                    var cellPhoneFormat = cellPhone.substring(0, 3) + '-' + cellPhone.substring(3, 6) + '-' + cellPhone.substring(6, 10);
                    var homePhoneFormat = homePhone.substring(0, 3) + '-' + homePhone.substring(3, 6) + '-' + homePhone.substring(6, 10);
                    this.phone = cellPhoneFormat + ',' + homePhoneFormat;
                  }

                }

                //*******Postal Code  */

                if (i.postalCode != '' || i.postalCode != undefined || i.postalCode != null) {
                  if (i.postalCode.length == 9) {
                    var postalcode = i.postalCode;
                    this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)

                  } else {
                    if (i.postalCode.length == 6 || i.postalCode.length == 7
                      || i.postalCode.length == 8) {

                      var postalcode = i.postalCode;
                      this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)
                    } else {
                      this.postalcodeFormat = i.postalCode;

                    }
                  }

                }

                // if (this.personalInfos[0].postalCode != '' || this.personalInfos[0].postalCode != undefined || this.personalInfos[0].postalCode != null) {
                //   if (this.personalInfos[0].postalCode.length == 9) {
                //     var postalcode = this.personalInfos[0].postalCode;
                //     this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)

                //   } else {
                //     if (this.personalInfos[0].postalCode.length == 6 || this.personalInfos[0].postalCode.length == 7
                //       || this.personalInfos[0].postalCode.length == 8) {
                //       var postalcode = this.personalInfos[0].postalCode;
                //       this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)
                //     } else {
                //       this.postalcodeFormat = this.personalInfos[0].postalCode;

                //     }
                //   }

                // }
                i.ssn = this.ssNumber;
                i.phone = this.phone;
                i.postalCode = this.postalcodeFormat;

                this.searchloading = false;
              })
            } else {
              this.ssNumber = '';
              this.phone = '';
              this.postalcodeFormat = '';
            }

            if (this.personalInfos.length == 0) {
              this.searchResultStatus = true;
              this.searchloading = false;
            }
            else {
              this.searchResultStatus = false;
            }
            this.personalInfos.forEach((element: IPersonalInfo) => {
              if (element.patientPic && element.patientPic != 'undefined')
                element.patientPic = 'data:image/jpeg;base64,' + element.patientPic;

              // element.ssn = this.ssNumber;
              // element.phone = this.phone;
              // element.postalCode = this.postalcodeFormat;

            });
            this.dataSource.data = this.personalInfos;
            //this.spinner.hide();
            this.dataSource.filterPredicate = this.createFilter();
            this.dataSource.paginator = this.paginator;
          }
          sessionStorage.removeItem("IsClosed");
        },
          (err: any) => {
            console.log(err)
            this.spinner.hide();
            this.searchResultStatus = false;
            this.searchloading = false;
          });
    } else {
      // this.dataSource.data = [];
      // alert('no data found.')
    }
  }

  checkInputfields: boolean = false;
  checkInputControldata() {
    if (this.PersonalSearchForm.value.patientId == "" && this.PersonalSearchForm.value.lastName == "" && this.PersonalSearchForm.value.firstName == ""
      && this.PersonalSearchForm.value.DOB == "" && this.PersonalSearchForm.value.SSN == "" && this.PersonalSearchForm.value.locations == ""
      && this.PersonalSearchForm.value.phone == "" && this.PersonalSearchForm.value.postalCode == "") {
      this.toastr.error('Please select atleast one field.')
      this.dataSource.data = [];
      this.checkInputfields = false;
    } else {
      this.checkInputfields = true;
    }
    return this.checkInputfields;
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.dPatId.toString().indexOf(searchTerms.patientId) !== -1
        && data.name.toString().toLowerCase().indexOf(searchTerms.name) !== -1
        && data.patDOB.toString().toLowerCase().indexOf(searchTerms.patDOB) !== -1
        && data.ssn.toString().toLowerCase().indexOf(searchTerms.ssn) !== -1
        && data.phone.toString().toLowerCase().indexOf(searchTerms.phone) !== -1
        && data.postalCode.toString().toLowerCase().indexOf(searchTerms.postalCode) !== -1
        // && data.locationName.toString().toLowerCase().indexOf(searchTerms.locationName) !== -1
        && (data.locationName === null ? "" : data.locationName).toString().toLowerCase().indexOf(searchTerms.locationName.toLowerCase()) !== -1
        && (data.PatientStatusName=== null ? "" : data.PatientStatusName).toString().toLowerCase().indexOf(searchTerms.PatientStatusName.toLowerCase()) !== -1
        && (data.PatientNotes=== null ? "" : data.PatientNotes).toString().toLowerCase().indexOf(searchTerms.PatientNotes.toLowerCase()) !== -1
        && (data.insurenceName=== null ? "" : data.insurenceName).toString().toLowerCase().indexOf(searchTerms.insurenceName.toLowerCase()) !== -1
        && (data.PlanName=== null ? "" : data.PlanName).toString().toLowerCase().indexOf(searchTerms.PlanName.toLowerCase()) !== -1
        && (data.MemberId=== null ? "" : data.MemberId).toString().toLowerCase().indexOf(searchTerms.MemberId.toLowerCase()) !== -1
        && (data.AccountNo=== null ? "" : data.AccountNo).toString().toLowerCase().indexOf(searchTerms.AccountNo.toLowerCase()) !== -1
        ;
    }
    return filterFunction;
  }

  // createsearchquery() {
  //   if (this.PersonalSearchForm.value != null) {
  //     this.searchquery = '';
  //     if (typeof this.PersonalSearchForm.value.patientId != 'undefined' && this.PersonalSearchForm.value.patientId)
  //       this.searchquery = this.searchquery + "patientId=" + this.PersonalSearchForm.value.patientId + "&&";
  //     if (typeof this.PersonalSearchForm.value.lastName != 'undefined' && this.PersonalSearchForm.value.lastName)
  //       this.searchquery = this.searchquery + "lastName=" + this.PersonalSearchForm.value.lastName + "&&";
  //     if (typeof this.PersonalSearchForm.value.firstName != 'undefined' && this.PersonalSearchForm.value.firstName)
  //       this.searchquery = this.searchquery + "firstName=" + this.PersonalSearchForm.value.firstName + "&&";
  //     if (typeof this.PersonalSearchForm.value.DOB != 'undefined' && this.PersonalSearchForm.value.DOB) {
  //       var selecteddate = this.datepipe.transform(this.PersonalSearchForm.value.DOB, 'yyyy-MM-dd');
  //       this.searchquery = this.searchquery + "DOB=" + selecteddate + "&&";
  //     }
  //     if (typeof this.PersonalSearchForm.value.SSN != 'undefined' && this.PersonalSearchForm.value.SSN)
  //       this.searchquery = this.searchquery + "SSN=" + this.PersonalSearchForm.value.SSN + "&&";
  //     if (typeof this.PersonalSearchForm.value.phone != 'undefined' && this.PersonalSearchForm.value.phone)
  //       this.searchquery = this.searchquery + "phone=" + this.PersonalSearchForm.value.phone + "&&";
  //     if (typeof this.PersonalSearchForm.value.postalCode != 'undefined' && this.PersonalSearchForm.value.postalCode)
  //       this.searchquery = this.searchquery + "ZIP=" + this.PersonalSearchForm.value.postalCode + "&&";
  //     // if (typeof this.PersonalSearchForm.value.isActive != 'undefined' && this.PersonalSearchForm.value.isActive)
  //     //   this.searchquery = this.searchquery + "isActive=false" + "&&";
  //     if (this.PersonalSearchForm.value.isActive )
  //     this.searchquery = this.searchquery + "isActive=" + this.PersonalSearchForm.value.isActive.toString() + "&&";

  //     if (typeof this.locationID[0].locationName != 'undefined' && this.locationID[0].locationName != "") {
  //       if (this.selectedLocationIds.length == 0)
  //         this.selectedLocationIds[0] = '0';
  //       this.searchquery = this.searchquery + "locationId=" + this.selectedLocationIds + "&&";
  //     }
  //     else if (this.locationID[0].locationName == "")
  //       this.searchquery = this.searchquery + "locationId=" + '0' + "&&";
  //     // else if (this.searchquery != '')
  //     //   this.searchquery = this.searchquery + "isActive=true" + "&&";
  //     if (this.searchquery != '')
  //       this.searchquery = this.searchquery + "facilityId=" + sessionStorage.getItem('FacilityId') + "&&";
  //     this.searchquery = this.searchquery.substring(0, this.searchquery.length - 2);
  //   }
  // }

  createsearchquery() {
    if (this.PersonalSearchForm.value != null) {
      this.searchquery = {
        patientId: null,
        lastName: '',
        firstName: '',
        DOB: '',
        SSN: '',
        ZIP: '',
        phone: '',
        userid: '',
        isActive: null,
        facilityId: null,
        locationId: '',
      }
      if (this.PersonalSearchForm.value.patientId != 'undefined' && this.PersonalSearchForm.value.patientId)
        this.searchquery.patientId = this.PersonalSearchForm.value.patientId;
      if (this.PersonalSearchForm.value.lastName != 'undefined' && this.PersonalSearchForm.value.lastName)
        this.searchquery.lastName = this.PersonalSearchForm.value.lastName;
      else {
        this.searchquery.lastName = null;
      }
      if (this.PersonalSearchForm.value.firstName != 'undefined' && this.PersonalSearchForm.value.firstName)
        this.searchquery.firstName = this.PersonalSearchForm.value.firstName;
      else {
        this.searchquery.firstName = null;
      }
      if (this.PersonalSearchForm.value.DOB != 'undefined' && this.PersonalSearchForm.value.DOB) {
        var selecteddate = this.datepipe.transform(this.PersonalSearchForm.value.DOB, 'yyyy-MM-dd');
        this.searchquery.DOB = selecteddate;
      } else {
        this.searchquery.DOB = null;
      }
      if (this.PersonalSearchForm.value.SSN != 'undefined' && this.PersonalSearchForm.value.SSN)
        this.searchquery.SSN = this.PersonalSearchForm.value.SSN;
      else {
        this.searchquery.SSN = null;
      }
      if (this.PersonalSearchForm.value.phone != 'undefined' && this.PersonalSearchForm.value.phone)
        this.searchquery.phone = this.PersonalSearchForm.value.phone;
      else {
        this.searchquery.phone = null;
      }
      if (this.PersonalSearchForm.value.postalCode != 'undefined' && this.PersonalSearchForm.value.postalCode)
        this.searchquery.ZIP = this.PersonalSearchForm.value.postalCode;
      else {
        this.searchquery.ZIP = null;
      }
      // if (typeof this.PersonalSearchForm.value.isActive != 'undefined' && this.PersonalSearchForm.value.isActive)
      //   this.searchquery = this.searchquery + "isActive=false" + "&&";
      if (this.PersonalSearchForm.value.isActive)
        this.searchquery.isActive = this.PersonalSearchForm.value.isActive;

      if (typeof this.locationID[0].locationName != 'undefined' && this.locationID[0].locationName != "") {
        if (this.selectedLocationIds.length == 0)
          this.selectedLocationIds[0] = '0';
        this.searchquery.locationId = this.selectedLocationIds.toString();
      }
      else if (this.locationID[0].locationName == "")
        this.searchquery.locationId = '0';
      // else if (this.searchquery != '')
      //   this.searchquery = this.searchquery + "isActive=true" + "&&";
      if (this.searchquery != null && this.searchquery != undefined)
        this.searchquery.facilityId = Number(sessionStorage.getItem('FacilityId'));
      //this.searchquery = this.searchquery.substring(0, this.searchquery.length - 2);
    }
  }

  clearSearch() {
    ;
    try {
      this.searchResultStatus = false;
      this.searchloading = false;
      //this.patIdFilter = new FormControl('');
      if (this.PersonalSearchForm != null) {
        if (this.PersonalSearchForm.value) {
          this.PersonalSearchForm.reset({
            'dPatId': '',
            'patientId': '',
            'lastName': '',
            'firstName': '',
            'DOB': '',
            'SSN': '',
            'phone': '',
            'postalCode': '',
            'isActive': '',
          });
        }
        this.selectedLocationIds = [];
        if (this.lstLocations) {
          for (let index = 0; index < this.lstLocations.length; index++) {
            this.lstLocations[index].selected = false;
          }
        }
      }
      if (this.personalInfos != undefined) {
        if (this.personalInfos.length > 0) {
          this.personalInfos = [];
          this.dataSource.data = [];
        }
      }


      this.clearfiltervalues();
    }
    catch (ex) {
      console.log(ex);

    }
  }

  clearfiltervalues() {
    this.patIdFilter.setValue("");
    this.patNameFilter.setValue("");
    this.patDOBFilter.setValue("");
    this.patSSNFilter.setValue("");
    this.patphoneFilter.setValue("");
    this.patZipFilter.setValue("");
    this.dpatIdFilter.setValue("");
    this.locationFilter.setValue("");

    this.PatientStatusFilter.setValue("");
    this.notesFilter.setValue("");
    this.InsuranceNameFilter.setValue("");
    this.PlanNameFilter.setValue("");
    this.memberIdFilter.setValue("");
    this.accountNoFilter.setValue("");
  }

  close() {
    ;
    this.clearSearch();
    try {
      if (sessionStorage.getItem("ispatSerachPopup") == "True") {

        this.dialogRef.close();

      }

      this.slideclose.emit("close");
      //this.dialogRef.close();
    }
    catch
    {
      this.slideclose.emit("close");
      // this.dialogRef.close();
    }
    sessionStorage.setItem("IsClosed", "yes");
  }

  oncellclick(element) {

    if (sessionStorage.getItem("ispatSerachPopup") == "True")
      this.dialogRef.close(element);
    // else
    //   this.getPopupAlertsInfo(element.patientId);

  }

  newAppointment(selectedRow: IAppointmentData) {
    this.close();

    if (selectedRow != null) {
      this.clearLock();
      this.selectedRowIndex = selectedRow.patientId;
      this.bannerService.toggle(selectedRow.patientId);
      sessionStorage.setItem("patientId", selectedRow.patientId.toString());
      sessionStorage.setItem("patientName", selectedRow.name);
      CommonComponents.patientId = selectedRow.patientId;
      CommonComponents.patientName = selectedRow.name;
      sessionStorage.removeItem("displayappDate");
      sessionStorage.removeItem("encounterid");
      CommonComponents.encounterId = null;
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      //this.router.navigateByUrl('/NewAppointment');
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/NewAppointment']));
    }
  }
  OnRx(selectedRow: IAppointmentData) {
    this.close();
    if (selectedRow != null) {
      if (selectedRow.patientId > 0) {
        this.getPopupAlertsInfo(selectedRow.patientId, 'IsRx');
      }
      this.clearLock();
      localStorage.removeItem("ordernoteheaderVisibility");
      sessionStorage.removeItem("patientId");
      sessionStorage.removeItem("patientName");
      sessionStorage.removeItem("encounterid");
      sessionStorage.removeItem("patientDob");
      CommonComponents.patientId = 0;
      CommonComponents.patientName = '';
      CommonComponents.encounterId = null;
      this.bannerService.toggle(Number("-1"));
      this.router.navigate(["Appointments"]);
      this.selectedRowIndex = selectedRow.patientId;
      this.bannerService.toggle(selectedRow.patientId);
      sessionStorage.setItem("patientId", selectedRow.patientId.toString());
      sessionStorage.setItem("patientName", selectedRow.name);
      sessionStorage.setItem("rxfromsearch", "true");
      sessionStorage.removeItem("displayappDate");
      CommonComponents.patientId = selectedRow.patientId;
      CommonComponents.patientName = selectedRow.name;
      CommonComponents.headerVisibility = false;
      CommonComponents.ordernoteheaderVisibility = false;
      // this.router.navigateByUrl('/Rx?patId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(selectedRow.patientId)));
      this.router.navigateByUrl('/', { skipLocationChange: true, preserveQueryParams: true }).then(() =>
        this.router.navigateByUrl('/Rx?fromSearch=true&&patId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(selectedRow.patientId))));
    }
  }

  patientAppointments(selectedRow: IAppointmentData) {
    this.close();
    if (selectedRow != null) {
      this.clearLock();
      this.selectedRowIndex = selectedRow.patientId;
      this.bannerService.toggle(selectedRow.patientId);
      sessionStorage.setItem("patientId", selectedRow.patientId.toString());
      sessionStorage.setItem("patientName", selectedRow.name);
      CommonComponents.patientId = selectedRow.patientId;
      CommonComponents.patientName = selectedRow.name;
      sessionStorage.removeItem("displayappDate");
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/PatientAppointments']));

    }
  }
  demographics(selectedRow: IAppointmentData) {
    // alert(selectedRow.start)
    this.close();
    if (selectedRow != null) {
      this.clearLock();
      if (selectedRow.patientId > 0) {
        this.getPopupAlertsInfo(selectedRow.patientId, '');
      }
      this.selectedRowIndex = selectedRow.patientId;
      this.bannerService.toggle(selectedRow.patientId);
      sessionStorage.setItem("patientId", selectedRow.patientId.toString());
      sessionStorage.setItem("patientName", selectedRow.name);
      if (selectedRow.dob != "" && selectedRow.dob != undefined && selectedRow.dob != null) {
        sessionStorage.setItem("patientDob", (this.transform(selectedRow.dob)));
      } else {
        sessionStorage.removeItem("patientDob");
      }
      sessionStorage.removeItem("displayappDate");
      CommonComponents.patientId = selectedRow.patientId;
      CommonComponents.patientName = selectedRow.name;
      sessionStorage.removeItem("AlertsheaderIconVisibility");
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/Demographics/Personal']));
      // if (selectedRow.patientId > 0) {
      //   if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
      //     var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isDemographics == true && attr.isDismiss == true);
      //     if (alertcount != null && alertcount.length > 0) {
      //       this.PopUpAlerts = alertcount;
      //       this.openAlertsPopup();
      //     }
      //   }
      // }
    }
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  openAlertsPopup(): void {
    const dialogRef = this.dialog.open(PopupAlertsComponent, {
      width: '1000px',
      height: '500px',
      data: this.PopUpAlerts

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)
        this.sharedService.lstPopUpAlerts = null;

    });
  }
  public visitDate: Date;
  documents(selectedRow: IAppointmentData) {
    this.close();
    if (selectedRow != null) {
      this.clearLock();
      this.selectedRowIndex = selectedRow.patientId;
      // this.visitDate=selectedRow.start;
      this.bannerService.toggle(selectedRow.patientId);
      sessionStorage.setItem("patientId", selectedRow.patientId.toString());
      sessionStorage.setItem("patientName", selectedRow.name);
      sessionStorage.removeItem("displayappDate");
      CommonComponents.patientId = selectedRow.patientId;
      CommonComponents.patientName = selectedRow.name;
      sessionStorage.removeItem("hideDocumentsHeader");
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/DocumentHome']));
      //this.router.navigateByUrl('/DocumentHome');
    }
  }


  newOrder(selectedRow: IAppointmentData) {
    CommonComponents.patientId = selectedRow.patientId;
    this.close();
    this.opneOrderInitiationDiaolg(selectedRow)
  }
  public locationName: number = 0;
  opneOrderInitiationDiaolg(app: IAppointmentData): void {
    const dialogRef = this.dialog.open(OrderNoteDialogComponent, {
      width: '500px',
      height: '250px',
      data: app,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.locationName = result.locationName;
      sessionStorage.setItem('WithoutAppOrderDate', result.orderDate);
      sessionStorage.setItem("displayappDate1", result.orderDate);
      if (app.patientId > 0) {
        this.getPopupAlertsInfo(app.patientId, 'Order Note');
        this.createNewOrder(result.provider, result.orderDate, app.patientId, app.Id, app.name, this.locationName)
      }
    });
  }

  createNewOrder(provider: string, orderDate: any, patId: number, appId: string, patName: string, locationId: number) {
    this.orderNote = new IOrderNote();
    this.orderNote.providerId = provider;
    this.orderNote.appointmentId = appId;
    this.orderNote.patId = patId;
    this.orderNote.locationId = locationId;
    var datePipe = new DatePipe("en-US");
    // this.orderNote.orderDate = new Date(datePipe.transform(orderDate, 'MM/dd/yyyy'));;
    this.orderNote.orderDate = new Date(this.datepipe.transform(orderDate, 'yyyy-MM-dd'));
    this.orderNote.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.patservice.createOrderNote(this.orderNote)
      .subscribe(result => {

        //alert(result)
        localStorage.setItem("ordernoteheaderVisibility", "True");
        CommonComponents.ordernoteheaderVisibility = true;

        if (result == -1) {
          CommonComponents.headerVisibility = false;
          this.toastr.warning("Order Note already created for this appointment");
        }
        else {
          sessionStorage.setItem("encounterid", result);
          CommonComponents.headerVisibility = false;
          this.selectedRowIndex = patId;
          this.bannerService.toggle(patId);
          sessionStorage.setItem("patientId", patId.toString());
          sessionStorage.setItem("patientName", patName);
          sessionStorage.removeItem("displayappDate");
          CommonComponents.patientId = patId;
          CommonComponents.patientName = patName;
          CommonComponents.headerVisibility = false;
          this.toastr.success("Order Note created succesfully");
          this.clearLock();
          this.router.navigateByUrl('/', { skipLocationChange: true, preserveQueryParams: true }).then(() =>
            this.router.navigateByUrl('/OrderNote?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(sessionStorage.getItem("encounterid")))));
        }
        // });
        // if (result == -1)
        //   this.toastr.warning("Order Note already created for this appointment");
        // else {
        //   this.selectedRowIndex = patId;
        //   this.bannerService.toggle(patId);
        //   sessionStorage.setItem("patientId", patId.toString());
        //   sessionStorage.setItem("patientName", patName);
        //   CommonComponents.patientId = patId;
        //   CommonComponents.patientName = patName;
        //   CommonComponents.headerVisibility = false;
        //   this.toastr.success("Order Note created succesfully");
        //   this.clearLock();
        //   this.router.navigateByUrl('/OrderNote?id=' + result);
        // }
      }
      );


  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  alphanumericonly(event): boolean {
    var regex = new RegExp("^[a-zA-Z0-9/b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  validateDate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 47) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  public todayDate = new Date();
  getPopupAlertsInfo(id: number, action: any) {
    var todayVisitDate: any = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy')
    this.sharedService.getAlertsInfo(id, todayVisitDate)
      .subscribe(
        (data: any) => {
          this.lstalerts = data;
          this.sharedService.lstPopUpAlerts = this.lstalerts;
          if (CommonComponents.patientId > 0) {
            if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
              // var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isDemographics == true && attr.isDismiss == true);
              if (action == 'IsRx') {
                var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isRx == true && attr.isDismiss == true);
              } else if (action == 'Order Note') {
                var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isOrderNote == true && attr.isDismiss == true);
              } else {
                var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isDemographics == true && attr.isDismiss == true);
              }
              alertcount = alertcount.filter((attr: IAlerts) => !attr.rolesName || attr.rolesName.includes(sessionStorage.getItem("role")));
              if (alertcount != null && alertcount.length > 0) {
                this.PopUpAlerts = alertcount;
                this.rolealert = "";
                this.PopUpAlerts.forEach(element => {
                  if (element.rolesName != null && element.rolesName != "") {
                    this.rolealert += element.rolesName + ',';
                  }
                });
                if (this.rolealert != null && this.rolealert != undefined && this.rolealert != "") {
                  if (this.rolealert.includes(sessionStorage.getItem("role"))) {
                    this.openAlertsPopup();
                  }
                } else {
                  this.openAlertsPopup();
                }
              }
            }
          }
        },
        (err: any) => console.log(err)
      );
  }


  clearLock() {
    this.lockService.deleteLockUsersInfo(sessionStorage.getItem("userId")).subscribe(data => {
    },
      (err: any) => console.log(err)
    );
  }

  NavigatetoPersonal(ele: any) {
    if (ele && ele != undefined) {
      if (ele.patientId > 0) {
        this.getPopupAlertsInfo(ele.patientId, '');
      }
      CommonComponents.patientId = ele.patientId;
      CommonComponents.patientName = ele.name;
      this.bannerService.toggle(ele.patientId);
      sessionStorage.setItem("patientId", ele.patientId.toString());
      sessionStorage.setItem("patientName", ele.name);
      sessionStorage.removeItem("displayappDate");
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      sessionStorage.removeItem("AlertsheaderIconVisibility");
      CommonComponents.demoheaderVisibility = true;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/Demographics/Personal']));
      this.close();
    }

  }

  //********* Newly Added Multiselect dropdown */
  UsersFocus() {
    //  $('#Usersfocushide').show();
    this.SelectedDropDownListId = true;
  }
  focusOutFunctionLocation(evn) {
    if (evn.keyCode === 9) {
      $('#locationsfocushide').hide()
      setTimeout(() => {
        this.saveUserId.nativeElement.focus();
      }, 100);

      this.SelectedDropDownListId = false;
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocus") {
      $('#locationlistoption0').focus();
    }
  }

  SelectedDropDownListId: boolean = false;
  arryOfselectedLocationsIdsUpdate: string[] = [];
  locationNameUpdate: string;
  locationsList: ILocationDetails[];
  selectedLocationIds: string[] = [];
  LocationSelectionChanged(LocationupdateRef) {
    this.selectAllLocations = false;
    this.locationsList = LocationupdateRef.selectedOptions.selected.map(item => item.value);
    this.locationNameUpdate = '';
    let selectedLocationsIdsUpdate = [];
    this.selectedLocationIds = [];
    this.arryOfselectedLocationsIdsUpdate = [];
    for (let index = 0; index < this.locationsList.length; index++) {
      this.locationNameUpdate += this.locationsList[index].locationName + ', ';
      selectedLocationsIdsUpdate.push(this.locationsList[index].locationId);
      this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
      this.arryOfselectedLocationsIdsUpdate.push(this.locationsList[index].locationId.toString())
    }

    if (this.locationsList.length > 0 && this.locationsList != null)
      this.isdisablebtns = false;
    else
      this.isdisablebtns = true;

    this.lstLocations.filter(x => x.selected = false) // default set false
    this.lstLocations.filter(x => selectedLocationsIdsUpdate.includes(x.locationId)).map(y => y.selected = true)

    this.PersonalSearchForm.patchValue({
      locations: this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2),
      IsLocationCheck: [false]
    })

    this.checkDefaultLocations();

  }
  checkDefaultLocations() {
    if (this.selectedList != null && this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.lstLocations.length) {
        this.PersonalSearchForm.patchValue({
          IsLocationCheck: false
        });
      } else {
        this.PersonalSearchForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.PersonalSearchForm.patchValue({
        IsLocationCheck: false
      });
    }

    if (selectProvlst.length > 0 || this.locationsList.length > 0)
      this.isdisablebtns = false;
    else
      this.isdisablebtns = true;
  }
  public lstLocations: ILocationDetails[];
  //public locationFilter: any;
  locationID: any;
  getLocationId: any;
  name: any;
  getLocations() {
    if ((sessionStorage.getItem("userId") || sessionStorage.getItem("FacilityId")))
      this.schedulerservice.getLocations().subscribe(data => {
        this.spinner.hide();
        this.lstLocations = data;
        this.selectedLocationIds = [];
        this.getLocationId = sessionStorage.getItem("LocationId"); //this.patservice.urlValue;//
        if(this.getLocationId != "0" && this.lstLocations.filter(x => x.locationId === Number(this.getLocationId)).length == 0) {
          this.locationID = this.lstLocations[0].locationName.toString();
           this.isdisablebtns = false;
        }
        else if (this.getLocationId == "0") {
          this.locationID = this.lstLocations[0].locationName.toString();
          this.isdisablebtns = true
        } else {
          this.locationID = this.lstLocations.filter(x => x.locationId === Number(this.getLocationId))
          this.selectedLocationIds.push(this.locationID[0].locationId);
          this.isdisablebtns = false;
        }

        this.lstLocations.filter(x => x.selected = false) // default set false
        this.lstLocations.filter(x => x.locationId == this.locationID[0].locationId).map(y => y.selected = true);

        this.PersonalSearchForm.patchValue({
          locations: this.locationID[0].locationName,
          IsLocationCheck: [true]
        });
       
      });

  }

  selectedList: ILocationDetails[];
  selected: string = "";
  selectedName: string;
  checkAllLocations(event) {

    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    this.selectAllLocations = ischk;
    if (ischk == true) {
      this.isdisablebtns = false;
      this.selectedList = [];
      this.selectedLocationIds = [];
      this.selected = '';
      this.locationNameUpdate = '';
      this.lstLocations = this.lstLocations.filter(x => x.selected = true)
      this.selectedList = this.lstLocations;

      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = true;
        this.selected += this.selectedList[index].locationId + ',';
        this.selectedLocationIds.push(this.selectedList[index].locationId.toString())

        //this.selectedLocationIds.push(this.selected);
        // this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
        this.locationNameUpdate += this.selectedList[index].locationName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.locationNameUpdate = this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2);
      }
      this.PersonalSearchForm.patchValue({
        locations: this.locationNameUpdate
      });
    } else {
      this.isdisablebtns = true;
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
      }
      this.selectedLocationIds = [];
      //this.selectedLocationIds.push('0')
      this.selected = '';
      this.selectedName = '';
      this.PersonalSearchForm.patchValue({
        locations: this.selectedName
      });
    }




  }

}

